export default __webpack_public_path__ + "static/santa-2-44e80f34809a578d97cfa83bcfd3730b.svg";